import type { OptionsDocument } from 'paintscout'

const timeZoneMap: Record<string, string> = {
  EST: 'America/New_York',
  EDT: 'America/New_York',
  CST: 'America/Chicago',
  CDT: 'America/Chicago',
  MST: 'America/Denver',
  MDT: 'America/Denver',
  PST: 'America/Los_Angeles',
  PDT: 'America/Los_Angeles'
}

function isValidIANATimeZone(tz: string): boolean {
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz })
    return true
  } catch {
    return false
  }
}

export function getTimezone({ options }: { options: OptionsDocument }): string {
  const timezone = options?.options?.timezone
  if (!timezone) {
    return 'America/New_York'
  }
  const mapped = timeZoneMap[timezone] || timezone
  return isValidIANATimeZone(mapped) ? mapped : 'America/New_York'
}
